(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zirben-autoplay-slide')) {
  customElements.define('zirben-autoplay-slide', class extends HTMLElement {
    connectedCallback() {
      this.video = document.getElementById(this.dataset.videoId);
      this.slide = this.closest('.slideshow__slide');
      this.carousel = this.closest('slideshow-component');

      if (!this.video || !this.slide || !this.carousel) return;

      this.slider = this.carousel.querySelector('[id^="Slider-"]');
      this.slideNumber = Array.from(
        this.carousel.querySelectorAll('.slideshow__slide')
      ).indexOf(this.slide) + 1;

      this.button = this.querySelector('.slideshow__video-toggle');
      this.autoplayButton = this.carousel.querySelector('.slideshow__autoplay');
      this.userPaused = false;
      this.rotationHeld = false;
      this.sync = this.sync.bind(this);
      this.toggle = this.toggle.bind(this);
      this.updateButton = this.updateButton.bind(this);
      this.onPlaying = this.onPlaying.bind(this);

      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.controls = false;

      this.carousel.addEventListener('slideChanged', this.sync);
      document.addEventListener('visibilitychange', this.sync);
      window.addEventListener('pageshow', this.sync);
      document.addEventListener('pointerdown', this.sync, true);
      document.addEventListener('keydown', this.sync, true);

      this.video.addEventListener('loadedmetadata', this.sync);
      this.video.addEventListener('loadeddata', this.sync);
      this.video.addEventListener('canplay', this.sync);
      this.video.addEventListener('playing', this.onPlaying);
      this.video.addEventListener('play', this.updateButton);
      this.video.addEventListener('pause', this.updateButton);

      this.stateObserver = new MutationObserver(this.sync);
      this.stateObserver.observe(this.slide, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });

      if (this.autoplayButton) {
        this.stateObserver.observe(this.autoplayButton, {
          attributes: true,
          attributeFilter: ['class']
        });
      }

      if (this.button) {
        this.button.addEventListener('click', this.toggle);
        this.button.hidden = false;
      }

      this.sync();
    }

    disconnectedCallback() {
      this.stateObserver?.disconnect();
      this.carousel?.removeEventListener('slideChanged', this.sync);

      document.removeEventListener('visibilitychange', this.sync);
      window.removeEventListener('pageshow', this.sync);
      document.removeEventListener('pointerdown', this.sync, true);
      document.removeEventListener('keydown', this.sync, true);

      this.video?.removeEventListener('loadedmetadata', this.sync);
      this.video?.removeEventListener('loadeddata', this.sync);
      this.video?.removeEventListener('canplay', this.sync);
      this.video?.removeEventListener('playing', this.onPlaying);
      this.video?.removeEventListener('play', this.updateButton);
      this.video?.removeEventListener('pause', this.updateButton);

      this.button?.removeEventListener('click', this.toggle);
      this.video?.pause();
      this.releaseRotation();
    }

    sync() {
      const width = Math.max(this.slide.clientWidth, 1);

      const currentPage =
        this.carousel.currentPage ||
        Math.round((this.slider?.scrollLeft || 0) / width) + 1;

      const active = currentPage === this.slideNumber;

      const carouselPaused =
        this.autoplayButton?.classList.contains(
          'slideshow__autoplay--paused'
        );

      const shouldPlay =
        active &&
        !document.hidden &&
        !this.userPaused &&
        !carouselPaused;

      if (this.button) {
        this.button.tabIndex = active ? 0 : -1;
      }

      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.autoplay = shouldPlay;

      if (!shouldPlay) {
        this.video.pause();

        if (!active) {
          this.releaseRotation();
        }
      } else {
        if (
          this.video.readyState < 2 &&
          this.slider?.dataset.autoplay === 'true' &&
          !this.rotationHeld &&
          typeof this.carousel.pause === 'function'
        ) {
          this.rotationHeld = true;
          this.carousel.pause();
        }

        if (this.video.paused) {
          const promise = this.video.play();

          promise?.catch((error) => {
            this.dataset.playback = 'blocked';

            if (error.name !== 'AbortError') {
              this.releaseRotation();
            }

            this.updateButton();
          });
        }
      }

      this.updateButton();
    }

    toggle() {
      this.userPaused = !this.video.paused;
      this.sync();
    }

    onPlaying() {
      this.updateButton();
      this.releaseRotation();
    }

    releaseRotation() {
      if (!this.rotationHeld) return;

      this.rotationHeld = false;

      const paused =
        this.autoplayButton?.classList.contains(
          'slideshow__autoplay--paused'
        );

      if (
        this.carousel?.isConnected &&
        this.slider?.dataset.autoplay === 'true' &&
        !paused &&
        !document.hidden &&
        typeof this.carousel.play === 'function'
      ) {
        this.carousel.play();
      }
    }

    updateButton() {
      if (!this.video.paused) {
        this.dataset.playback = 'playing';
      }

      if (!this.button) return;

      this.button.dataset.paused = String(this.video.paused);

      this.button.setAttribute(
        'aria-label',
        this.video.paused
          ? this.button.dataset.playLabel
          : this.button.dataset.pauseLabel
      );
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
